
















import Vue from 'vue'
import {Component} from "vue-property-decorator";

@Component
export default class Labels extends Vue{
  tags = JSON.parse(window.localStorage.getItem('tags')!);
  createTag(){
    const tagName = window.prompt('请输入新的标签名');
    if (tagName === '' || tagName === null) {
      window.alert('标签名不能为空');
    } else if (this.tags?.includes(tagName!)){
      window.alert('标签名已存在');
    }else if (this.tags) {
      this.tags.push(tagName);
      window.localStorage.setItem('tags',JSON.stringify(this.tags));
    }
  }
}
